import { Chip, ChipProps } from "@mui/material";
import { ClockStatus } from "generated-graphql/graphql";

import { CLOCK_STATUS_LABELS } from "./containerDisplay";

/**
 * Chips follow the design-system spec: small, outlined, MUI semantic palette
 * colors (never solid dark fills). NONE (no applicable limit, or an
 * unresolvable generator status) omits `color` for the plain grey outline —
 * it isn't a problem state, just an absence of one.
 */
const CLOCK_STATUS_CHIP_COLORS: Record<ClockStatus, ChipProps["color"] | undefined> = {
  [ClockStatus.Ok]: "success",
  [ClockStatus.Approaching]: "warning",
  [ClockStatus.OverLimit]: "error",
  [ClockStatus.Overdue]: "error",
  [ClockStatus.None]: undefined,
};

export function WasteContainerClockChip({ status }: { status: ClockStatus }) {
  return (
    <Chip
      label={CLOCK_STATUS_LABELS[status]}
      size="small"
      variant="outlined"
      color={CLOCK_STATUS_CHIP_COLORS[status]}
    />
  );
}
